/**************************************************
 * Nombre:       Tarjeta_Productos
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import imgDefecto from '../../Recursos/img_defecto.png'
import {theme} from "../../Tema";
import {ShoppingCart} from '@mui/icons-material'
import {formatoMoneda} from "../../Utilidades/formatoMoneda";
import {adap_producto} from "../../Modulo_Carrito_Wass/Adaptadores/adap_producto";
import {useFuncionesCarrito} from "../../Modulo_Carrito_Wass/Hooks/useFuncionesCarrito";
import {useNavigate} from "react-router-dom";
import {useResponsive} from "../../Modulo_Responsive/Hooks/useResponsive";


const Tarjeta_Productos = ({item}) => {
    const {adicionarProducto, verificarProductoCarrito} = useFuncionesCarrito()
    const navigate = useNavigate()
    const {sCell} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                backgroundColor: '#FFF',
                strokeWidth: 0.5,
                stroke: 'rgba(0, 0, 0, 0.10)',
                filter: 'drop-shadow(0px 2px 20px rgba(0, 0, 0, 0.10))',
                p: 1,
                borderRadius: 1.5
            }}
        >

            <Grid

                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{cursor: 'pointer'}}
            >

                <Grid
                    onClick={() => navigate('/Detalle/' + item.id)}
                    container
                    justifyContent={'flex-start'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 12}}
                    sx={{cursor: 'pointer'}}
                >


                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{mb: -3.4, zIndex: 2}}>
                        {item.oferta === 'Si' &&
                            <Typography sx={{
                                backgroundColor: '#E4061350',
                                color: '#fff',
                                px: 3,
                                py: 0.1,
                                borderRadius: 1,
                                fontSize: 14,
                                fontWeight: 600
                            }}>Oferta</Typography>
                        }
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{zIndex: 1}}>
                        <img src={item.img ? item.img : imgDefecto} width={'100%'} height={'auto'}
                             style={{borderRadius: 5}}

                        />
                    </Grid>

                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'center'}
                        size={{xs: 12, sm: 12, md: 12}}
                        sx={{p: 2, mt: -2, mb: -1}}
                    >

                        <Grid container size={{xs: 12, sm: 12, md: 12}}>
                            <Typography sx={{color: '#868686', fontSize: 14, fontWeight: 600}}>{item.marca}</Typography>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{mt: 0}}>
                            <Typography
                                sx={{
                                    color: '#000000',
                                    fontSize: sCell ? 22 : 18,
                                    fontWeight: 600,
                                    lineHeight: 1.2
                                }}>{item.nombre}</Typography>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{mt: 0.5}}>
                            <Typography sx={{
                                backgroundColor: theme.palette.primary.main + 40,
                                color: theme.palette.primary.main,
                                px: 2,
                                py: 0.1,
                                borderRadius: 1,
                                fontSize: 12,
                                fontWeight: 400
                            }}>{item.presentacion}</Typography>
                        </Grid>


                    </Grid>

                </Grid>

                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'center'}
                    size={{xs: 12, sm: 12, md: 12}} sx={{pb: 2, px: 2}}>

                    <Grid container size={{xs: 12, sm: 12, md: 6}} sx={{mt: 2}}>

                        <Grid
                            container
                            justifyContent={'flex-start'}
                            alignItems={'flex-start'}
                            size={{xs: 12, sm: 12, md: 12}}>

                            {item && item.oferta === 'Si' && item.valorAntes &&
                                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                                    <Typography
                                        sx={{
                                            color: '#00000080',
                                            fontSize: sCell ? 14 : 12,
                                            fontWeight: 600,
                                            textDecoration: sCell ? 'none' : 'line-through',
                                        }}>{`${sCell ? 'Antes: ' : ''} ${formatoMoneda(item.valorAntes)}`}</Typography>
                                </Grid>
                            }

                            <Grid container size={{xs: 12, sm: 12, md: 12}}
                                  sx={{justifyContent: 'flex-start', mt: -0.5}}>
                                <Typography
                                    sx={{
                                        color: '#000000',
                                        fontSize: sCell ? 20 : 18,
                                        fontWeight: 600
                                    }}>{formatoMoneda(item.valor)}</Typography>
                            </Grid>

                        </Grid>

                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 6}} sx={{mt: 1, justifyContent: 'flex-end'}}>

                        <Grid
                            container
                            justifyContent={'flex-start'}
                            alignItems={'flex-start'}
                            size={{xs: 12, sm: 12, md: 12}}>


                            <Grid container size={{xs: 12, sm: 12, md: 12}}
                                  sx={{mt: sCell ? -4.5 : -2.5, justifyContent: 'flex-end', mb: 0.5}}>
                                {verificarProductoCarrito(item) > 0 &&
                                    <Typography
                                        sx={{
                                            fontSize: sCell ? 18 : 12,
                                            color: theme.palette.primary.main,
                                            textAlign: 'rigth',
                                            fontWeight: 600
                                        }}>{`${verificarProductoCarrito(item)} en carrito`}</Typography>
                                }
                            </Grid>

                            <Grid container size={{xs: 12, sm: 12, md: 12}}>

                                {(item.estado && item.estado === 'Sin Stock') || item.valor <= 0 ?

                                    <Button
                                        disabled={true}
                                        fullWidth sx={{px: 1}}>
                                        Sin Stock
                                    </Button>

                                    :
                                    <Button
                                        fullWidth

                                        onClick={() =>
                                            adicionarProducto(
                                                adap_producto({
                                                    producto: item
                                                }))}

                                        startIcon={<ShoppingCart sx={{height: 18, width: 18}}/>}
                                        sx={{backgroundColor: '#495BFFCC', fontSize: sCell ? 18 : 14}}
                                    >Agregar</Button>
                                }


                            </Grid>

                        </Grid>

                    </Grid>


                </Grid>


            </Grid>


        </Grid>
    )

}
export default Tarjeta_Productos